import { useSelector } from 'react-redux'
import type { FacetInput } from 'api/schemas'
import { ls } from 'utils/my-localstorage'
import {
  CHECKBOX_LIST,
  DATE_INTERVAL,
  filterTypes,
  INTERVAL,
  NUMBER,
  RADIO_LIST,
  RHEOSTAT,
  SCORE,
  SEARCH_USERS,
  SWITCHER,
  myReviewsFiltersName,
  MULTISELECT_SWITCHER,
} from 'utils/consts'
import { useFilterStoreData } from 'utils/hooks/useFilterStoreData'
import type { RootState } from 'store'
import { getMyReviewsFiltersCollection } from 'utils/filtersCollections'

export const useMyReviewsFiltersInputs = () => {
  const { storeName, filtersStorageName } = useFilterStoreData()

  const filtersFromStorage = ls.getObject(filtersStorageName)

  const filtersFromStore = useSelector(
    (state: RootState) => state?.tableFilters?.[storeName]?.filters
  )

  const getTableFilters = (
    filters: Record<string, any>
  ): FacetInput[] | null => {
    const inputs: FacetInput[] = []

    const myReviewsFiltersCollection = getMyReviewsFiltersCollection()

    for (const [key, value] of Object.entries(filters ?? {})) {
      const filterFromCollection = myReviewsFiltersCollection.find(
        item => item.filterName === key
      )

      if (!filterFromCollection) continue

      switch (filterFromCollection.type) {
        case filterTypes[CHECKBOX_LIST]:
          if (value?.length > 0 && value != -1) {
            inputs.push({
              listInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break
        case filterTypes[SEARCH_USERS]:
          if (value?.length > 0) {
            inputs.push({
              freeListInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break
        case filterTypes[DATE_INTERVAL]:
          inputs.push({
            dateRangeInput: {
              key: filterFromCollection?.apiFilterName,
              fromDate: value?.fromDate,
              toDate: value?.toDate,
            },
          })
          break
        case filterTypes[RADIO_LIST]:
          inputs.push({
            listInput: {
              key: filterFromCollection?.apiFilterName,
              byName: value,
            },
          })
          break
        case filterTypes[RHEOSTAT]:
        case filterTypes[INTERVAL]:
          inputs.push({
            rangeInput: {
              key: filterFromCollection?.apiFilterName,
              ...value,
            },
          })
          break
        case filterTypes[SCORE]:
          if (value != -1) {
            inputs.push({
              listInput: {
                key: filterFromCollection?.apiFilterName,
                byName: value,
              },
            })
          }
          break

        case filterTypes[MULTISELECT_SWITCHER]:
          if (
            filterFromCollection?.filterName ==
              myReviewsFiltersName?.grapesFilter &&
            (value?.list?.length > 0 || value?.switcher)
          ) {
            inputs.push({
              complexInput: {
                key: 'grapeAndMonocepage',
                childrenInputs: [
                  {
                    booleanInput: {
                      key: 'grapeAndMonocepage.monocepage',
                      value: value?.switcher,
                    },
                  },
                  {
                    listInput: {
                      key: 'grapeAndMonocepage.grape',
                      byName: value?.list,
                    },
                  },
                ],
              },
            })
          }
          break

        case filterTypes[SWITCHER]:
          inputs.push({
            booleanInput: {
              key: filterFromCollection?.apiFilterName,
              value: value,
            },
          })
          break
        case filterTypes[NUMBER]:
          inputs.push({
            rangeInput: {
              key: filterFromCollection?.apiFilterName,
              minValue: value,
            },
          })
          break

        default:
          break
      }
    }

    return inputs.length ? inputs : null
  }

  return { getTableFilters, filtersFromStore, filtersFromStorage }
}
